import { render, staticRenderFns } from "./CustomerAdvance.vue?vue&type=template&id=4f83e29a&"
import script from "./CustomerAdvance.vue?vue&type=script&lang=js&"
export * from "./CustomerAdvance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports